import {createReducer, on} from '@ngrx/store';
import {ConfigurationActions} from '../actions/configuration.action';

export interface ConfigurationState {
  /**
   * The URL used for cancellation should be a valid URL string.
   * @example 'https://store.sap.com/whatever/en'
   */
  cancellationUrl: string;
}

/**
 * Initial state with an empty `cancellationUrl`, to be replaced by the consumer when registering the feature state in the store.
 */
export const initialConfigurationState: ConfigurationState = {
  cancellationUrl: '', // Consumer must provide a valid URL
};

/**
 * It is crucial that the consumer provides an initialState with a valid `cancellationUrl`. If a valid URL is not provided, it will lead to issues, such as navigating to an empty or invalid URL.
 *
 * Example usage in the consumer's cart module:
 * ```typescript
 * StoreModule.forFeature(
 *   configurationFeatureKey,
 *   configurationReducer,
 *   { initialState: { cancellationUrl: 'https://store.sap.com/dcp/en' } } // Consumer-provided initial state
 * );
 * ```
 */
export const configurationReducer = createReducer(
  initialConfigurationState,
  on(ConfigurationActions.updateConfiguration, (state, {cancellationUrl}) => ({
    ...state,
    cancellationUrl,
  })),
);
